const initialRecipes = [
    {
        name: 'Turkey Tacos',
        ingredients: '1 lb. ground turkey, 1 large onion, 2 tbsp. olive oil, 1 can black beans, 2 tomatoes, 1/4 cup chili powder, salt, pepper, whatever spices you like, shredded cheddar cheese, tortillas',
        directions: 'In a large skillet heat oil and saute onions with salt, Brown turkey, Add beans tomatoes and spices, Cook until most liquid has evaporated, Warm tortillas and wrap taco mixture with cheese, Enjoy!',
        key: 2
    }, {
        name: 'Hamburger',
        ingredients: 'Ground beef, Bun, Mustard, Mayo, Pickle',
        directions: 'Form beef into patty, Cook on skillet or grill until medium rare, Apply mayo and mustard to bun, Assemble with pickle on top, WARNING!!!  DO NOT ADD KETCHUP!',
        key: 0
    }, {
        name: 'Hamburger Helper',
        ingredients: 'Hamburger don\'t need no help',
        directions: 'Just make a burger instead',
        key: 1
    }
];

export default initialRecipes


// WEBPACK FOOTER //
// ./src/initialRecipes.js